import ApiCall from "../Apicall/ApiCall.js";

// Reports a deal step that only the browser can see (the QR scan, a party's price confirmation) to
// the deal log (tbl_DealLog). Best effort: a failed log write must never interrupt the deal itself.
// The server decides the actor, the role and the price from the signed-in user and the contract.
export async function logDealEvent(contractMainId, eventType) {
  if (!contractMainId || !eventType) return;
  try {
    await ApiCall({
      url: "/DealLog/LogEvent",
      method: "POST",
      data: { contractMainId: Number(contractMainId), eventType },
    });
  } catch (_) {
    /* the deal continues without this log line */
  }
}
